import { Link } from "react-router-dom";
import { mediaUrl } from "@/lib/api";

/**
 * Circle-style category card:
 *  - Perfect circle with thick yellow border on black bg
 *  - Product image inside
 *  - Black pill nameplate with yellow border overlapping bottom, white bold uppercase text
 */
export default function CategoryBlobCard({ cat, testid }) {
  return (
    <Link
      to={`/kategori/${cat.slug}`}
      data-testid={testid || `cat-blob-${cat.slug}`}
      className="group relative block"
    >
      <div className="relative aspect-square bg-white rounded-full border-[4px] sm:border-[5px] border-[#FFD600] overflow-hidden transition-transform duration-300 group-hover:scale-[1.02] group-hover:shadow-[0_0_30px_rgba(255,214,0,0.35)]">
        {cat.image ? (
          <img
            src={mediaUrl(cat.image)}
            alt={cat.name}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-neutral-400 text-xs uppercase tracking-wider">
            Pa foto
          </div>
        )}
      </div>
      {/* Solid yellow pill nameplate with thin BLACK outline + bold black text */}
      <div className="absolute bottom-[10%] left-1/2 -translate-x-1/2 w-[85%] max-w-[240px] bg-[#FFD600] border-[1.5px] border-black rounded-full px-3 py-1.5 text-center shadow-[0_0_20px_rgba(255,214,0,0.55),0_4px_12px_rgba(0,0,0,0.6)]">
        <div className="text-black font-black text-[12px] sm:text-base tracking-wide leading-tight">
          {cat.name}
        </div>
      </div>
    </Link>
  );
}
